<template>
  <a-modal
    :visible="visible"
    title="退货单详情"
    :width="900"
    :footer="null"
    @cancel="handleCancel"
  >
    <div v-if="detail">
      <!-- 基本信息 -->
      <a-descriptions title="基本信息" :column="2" bordered>
        <a-descriptions-item label="退货单号">{{ detail.returnNo }}</a-descriptions-item>
        <a-descriptions-item label="要货单号">{{ detail.purchaseOrderNo }}</a-descriptions-item>
        <a-descriptions-item label="门店名称">{{ detail.storeName }}</a-descriptions-item>
        <a-descriptions-item label="商家名称">{{ detail.merchantName }}</a-descriptions-item>
        <a-descriptions-item label="退货金额">
          <span style="color: #ff4d4f; font-weight: bold;">¥{{ detail.returnAmount }}</span>
        </a-descriptions-item>
        <a-descriptions-item label="退货时间">{{ detail.returnTime }}</a-descriptions-item>
        <a-descriptions-item label="创建人">{{ detail.creatorName }}</a-descriptions-item>
        <a-descriptions-item label="创建时间">{{ detail.createTime }}</a-descriptions-item>
        <a-descriptions-item label="备注" :span="2">{{ detail.remark || '-' }}</a-descriptions-item>
      </a-descriptions>

      <!-- 退货明细 -->
      <a-divider orientation="left">退货明细</a-divider>
      <a-table
        :columns="itemColumns"
        :data-source="detail.items"
        :row-key="record => record.id"
        :pagination="false"
        size="small"
      >
        <template slot="goodsInfo" slot-scope="text, record">
          <div>{{ record.goodsName }}</div>
          <div style="color: #999; font-size: 12px;">{{ record.skuName }}</div>
        </template>
        <template slot="returnAmount" slot-scope="text, record">
          <span style="color: #ff4d4f;">¥{{ (record.unitPrice * record.returnCount).toFixed(2) }}</span>
        </template>
      </a-table>

      <!-- 合计 -->
      <div style="text-align: right; margin-top: 16px; padding-right: 24px;">
        <span style="font-size: 16px;">合计：</span>
        <span style="font-size: 20px; color: #ff4d4f; font-weight: bold;">¥{{ detail.returnAmount }}</span>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { getReturnDetail } from '@/api/retail/purchase'

export default {
  name: 'ReturnDetailModal',
  data() {
    return {
      visible: false,
      detail: null,
      // 明细列表表头
      itemColumns: [
        {
          title: '商品信息',
          dataIndex: 'goodsInfo',
          align: 'center',
          scopedSlots: { customRender: 'goodsInfo' },
          width: 250
        },
        {
          title: '退货数量',
          dataIndex: 'returnCount',
          align: 'center',
          width: 100
        },
        {
          title: '单价',
          dataIndex: 'unitPrice',
          align: 'center',
          customRender: (text) => `¥${text}`,
          width: 100
        },
        {
          title: '退货金额',
          dataIndex: 'returnAmount',
          align: 'center',
          scopedSlots: { customRender: 'returnAmount' },
          width: 120
        }
      ]
    }
  },
  methods: {
    /**
     * 打开弹窗
     */
    open(returnId) {
      this.visible = true
      this.loadDetail(returnId)
    },

    /**
     * 加载详情
     */
    loadDetail(returnId) {
      getReturnDetail(returnId).then(res => {
        console.log(1111, res)
        this.detail = res.data
      })
    },

    /**
     * 取消
     */
    handleCancel() {
      this.visible = false
      this.detail = null
    }
  }
}
</script>
